import { Component, ElementRef, OnInit, EventEmitter, Output, ViewChild, ViewChildren, QueryList, HostListener } from '@angular/core';
import { Router } from "@angular/router";
import { ServiceStock } from '../service-stock.service';
import { ProvidehttpService } from '../providehttp.service';
import { ExchangeComponent } from '../gotx/components/Exchange/Exchange.component';
import { NotificationService } from '../notification.service';
import { ProductComponent } from '../gotx/components/Product/Product.component';
import { SocketioService } from '../socketio.service';

declare let $: any;
declare let document: any;
window["$"] = $;
window["jQuery"] = $;
@Component({
  selector: 'app-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss'],
})
export class MainHeaderComponent implements OnInit {
 // @ViewChild('cstmProduct', { static: false }) cstmProduct: ProductComponent;
  public themeMode: string = '';
  notifs: any = [];
  downloads: any = [];
  serviceListObj: any;
  searchText: String;

  showLogin = false;
  showDownloads = false;
  showNotification = false;
  showSearchBar = false;
  showProductFlag = false;

  languages = [];
  selectedlang: string;
  productSource: any;

  @Output() selectedMenu = new EventEmitter<String>();

  serviceList = [];
  // userName: string;
  // userID: string;
  // LastLogin: string;
  notificationLength = 0;
  downloadsLength = 0;

  blockSize: number = 10;
  enableLoadNotifs: boolean = false;
  isLoadingNotifs: boolean = false;
  selectedService: any;
  isShowUnread: boolean = true;
  notificationUnreadLenth;
  displayProduct: string;

  @ViewChild('loginDiv', { static: false }) loginDiv: ElementRef;//userInfo
  @ViewChild('userInfo', { static: false }) userInfo: ElementRef;
  @ViewChild('notificationDiv', { static: false }) notificationDiv: ElementRef;
  @ViewChild('downloadsDiv', { static: false }) downloadsDiv: ElementRef;


  @ViewChild('cstmExchange', { static: false }) cstmExchange: ExchangeComponent;

  constructor(private router: Router, public services: ServiceStock, public dataService: ProvidehttpService,
    public notifyService: NotificationService, private socketio: SocketioService,) {
    this.selectedlang = this.services.http.currentLanguage;
  }
  public navbarSearchOpen = false;

  // ngAfterContentInit() {
  //   this.userName = this.services.dataStore.getData('userName');
  //   // this.userID = this.services.dataStore.getData('userId');
  //   let lastdate = this.services.dataStore.getData('lastloginDate');
  //   let lastTime = this.services.dataStore.getData('lastloginTime');

  //   try {
  //     if (lastdate != null && typeof lastdate != "undefined") {
  //       this.LastLogin = lastdate.slice(6, 8).concat("/").concat(lastdate.slice(4, 6)).concat("/").concat(lastdate.slice(0, 4));
  //     } 
  //     if (lastTime != null) {
  //       this.LastLogin += " "
  //       this.LastLogin += this.services.timePipe.transform(lastTime);
  //     } else {
  //       this.LastLogin = "-";
  //     }
  //   } catch (error) {
  //     this.LastLogin = "-";
  //   }
  // }

  ngOnInit() {
    this.services.dataStore.currentMessage.subscribe(message => {
    this.displayProduct = message;
    });
  }

  routToMyTray() {
    this.router.navigate(['/home/MyWorkflow']);
  }
  toggleFullScreen() {
    if (!document.fullscreenElement && // alternative standard method
      !document.mozFullScreenElement && !document.webkitFullscreenElement) { // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen((<any>Element).ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
    $("#ToggleFullScreen").toggleClass("fa-expand");
    $("#ToggleFullScreen").toggleClass("fa-compress");
  }

  showMenuVar = true;

  toggleMenu() {
    this.services.http.showMenu = !this.services.http.showMenu;
    $('.open-child-menu').toggleClass('open-child-menu');
  }

  showMenu(val) {
    this.showMenuVar = val;
    if (val) {
      document.getElementById('pageBody').classList.remove('sidebar-hide');
    } else {
      document.getElementById('pageBody').classList.add('sidebar-hide');
    }
  }
 /* logout() {
    this.services.logout();
  }*/

    async logout() {
  const result = await this.services.logout();

  if (result === 0) {
    console.log('Logout success');
    this.socketio.disconnect();
    this.router.navigate(['/login']);
  }
}

  handleThemeMode() {

    let THEME_MODE = localStorage.getItem('THEME_MODE');
    this.themeMode = THEME_MODE;

    if (THEME_MODE === 'light') {
      localStorage.setItem('THEME_MODE', 'dark');

    } else {
      localStorage.setItem('THEME_MODE', 'light');

    }
    this.services.theme.setDarkThemeMode();

  }

  handleMenuClick(menuName: string) {
    this.selectedMenu.emit(menuName);
  }

  onSelectionChange(language: any) {
    // console.log('onSelectionChange',language)
    this.services.translate.use(language);
  }
}
